import i18n from "i18next"

import type { PerformanceScore } from "./types"

const EMPTY = "—"

const compactUsd = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  notation: "compact",
  maximumFractionDigits: 1
})

export const formatMoney = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return EMPTY
  if (value === 0) return "$0"
  return compactUsd.format(value)
}

export const formatPercent = (value: number | null | undefined): string =>
  value === null || value === undefined ? EMPTY : `${value}%`

export const formatDays = (value: number | null | undefined): string =>
  value === null || value === undefined ? EMPTY : `${value.toFixed(1)} d`

export const formatScore = (
  score: Pick<PerformanceScore, "value" | "available">
): string =>
  score.available && score.value !== null ? String(score.value) : EMPTY

export const formatSignedDays = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return EMPTY
  if (value === 0) return "0 d"
  const magnitude = Number.isInteger(value)
    ? String(Math.abs(value))
    : Math.abs(value).toFixed(1)
  return `${value > 0 ? "+" : "−"}${magnitude} d`
}

export const formatPoints = (value: number | null | undefined): string =>
  value === null || value === undefined
    ? EMPTY
    : `${value > 0 ? "+" : value < 0 ? "−" : ""}${Math.abs(value).toFixed(1)} pts`

export const formatDate = (iso: string | null | undefined): string => {
  if (!iso) return EMPTY
  const [y, m, d] = iso.split("-").map(Number)
  return new Date(y, m - 1, d).toLocaleDateString(i18n.language || "en", {
    month: "short",
    day: "numeric",
    year: "numeric"
  })
}
